<template>
	<b-row>
		<b-col cols="12">
			<div id="parentx">
				<transition name="slide">
					<b-card>
						<div slot="header">
							{{ $t(caption) }}
							<div class="card-header-actions">
								<vs-dropdown vs-custom-content vs-trigger-click>
									<b-link href.prevent class="card-header-action btn-setting" style="font-size: 15px">
										<i class="fa fa-th"></i>
									</b-link>
									<vs-dropdown-menu class="columns-dropdown">
										<visible-columns :default-fields="refField"
											@result="columnListener"></visible-columns>
									</vs-dropdown-menu>
								</vs-dropdown>
							</div>
						</div>
						<b-card-body>
							<filter-good excel-hidden @search="filterItems">1</filter-good>
							<b-modal :title="$t('barcode-count')" v-model="confirmBarcodeGenerate"
								@close="cancelBarcodeGenerate" no-close-on-backdrop size="xl">
								<table class="table table-bordered mt-3" style="margin-right: 10px;margin-left: 10px;">
									<thead>
										<tr>
											<th style="width: 30px;text-align: center">№</th>
											<th style="width: 350px;text-align: center">
												{{ $t('sidebar.warehouse-management.products') }}
											</th>
											<th style="width: 240px;text-align: center">Штрих-код</th>
											<th style="width: 240px;text-align: center">{{
												$t('promo-to-product.department') }}</th>
											<th>{{ $t('goods.amount') }}</th>
										</tr>
									</thead>
									<tr cols="12">
										<td style="text-align: center">
											1
										</td>
										<td>{{ calculateCount.name }} / <strong> {{ calculateCount.barcode }} / {{
											calculateCount.artikul }}</strong></td>
										<td>
											<b-form-select v-model="multiBarcodes" :options="multiBarcodesAll"
												value-field="id" text-field="name">
												<template slot="first">
													<option :value="null">-- Все --</option>
												</template>
											</b-form-select>
										</td>
										<td>
											<b-form-select v-model="depId" :options="departments" value-field="id"
												text-field="name" size="sm">
												<template slot="first">
													<option :value="null">--{{ $t('promo-to-product.department') }}--
													</option>
												</template>
											</b-form-select>
										</td>
										<td>
											<b-col>
												<b-input-group size="sm">
													<b-form-input v-model="barcodeCount" size="sm" autocomplete="off"
														type="number"></b-form-input>
													<b-input-group-addon>
														<b-button size="sm" disabled>
															{{ calculateCount.unitName }}
														</b-button>
													</b-input-group-addon>
												</b-input-group>
											</b-col>
										</td>
									</tr>
								</table>

								<div slot="modal-footer">
									<b-button variant="success" size="sm" class="float-right ml-2"
										@click="submitBarcodeGenerate">
										{{ $t('save') }}
									</b-button>

									<b-button variant="primary" size="sm" class="float-right"
										@click="cancelBarcodeGenerate">
										{{ $t('cancel') }}
									</b-button>
								</div>


							</b-modal>
							<b-modal title="Введите количество ценников для печати" v-model="confirmPriceGenerate"
								size="xl">
								<table class="table table-bordered mt-3" style="margin-right: 10px;margin-left: 10px;">
									<thead>
										<tr>
											<th style="width: 30px;text-align: center">№</th>
											<th class="text-center">{{ $t('sidebar.warehouse-management.products') }}
											</th>
											<th class="text-center">Штрих-код</th>
											<th class="text-center">{{ $t('promo-to-product.department') }}</th>
											<th style="width: 250px" class="text-center">{{ $t('goods.amount') }}</th>
										</tr>
									</thead>
									<tr cols="12">
										<td class="text-center">1</td>
										<td>{{ pricingItem.name }} / <strong> {{ pricingItem.barcode }} </strong></td>
										<td>
											<b-form-select v-model="multiBarcodes" :options="multiBarcodesAll"
												value-field="id" text-field="name" size="sm">
												<template slot="first">
													<option :value="null">--Штрих-код--</option>
												</template>
											</b-form-select>
										</td>
										<td>
											<b-form-select v-model="departmentId" :options="departments"
												value-field="id" text-field="name" size="sm">
												<template slot="first">
													<option :value="null">--Отдел--</option>
												</template>
											</b-form-select>
										</td>
										<td>
											<b-input-group size="sm">
												<b-form-input v-model="priceCount" size="sm" autocomplete="off"
													type="number"></b-form-input>
												<b-input-group-addon>
													<b-button size="sm" disabled>
														{{ pricingItem.unitName }}
													</b-button>
												</b-input-group-addon>
											</b-input-group>
										</td>
									</tr>
								</table>
								<div slot="modal-footer">
									<b-button variant="success" size="sm" class="float-right ml-2"
										@click="submitPriceGenerate">
										{{ $t('save') }}
									</b-button>
									<b-button variant="primary" size="sm" class="float-right"
										@click="cancelPriceGenerate">
										{{ $t('cancel') }}
									</b-button>
								</div>
							</b-modal>
							<!-- TABLE -->
							<div class="table-responsive table-wrapper">
								<b-table responsive="true" class="generalTableClass" :items="items"
									:fields="computedFields" :current-page="search.limit" :per-page="0" hover="hover"
									striped="striped" bordered="bordered" show-empty>
									<!-- EMPTY SLOT FOR TABLE -->
									<template slot="empty" slot-scope="scope">
										<h4>{{ $t('empty') }}</h4>
									</template>
									<!-- EMPTY SLOT FOR TABLE -->

									<template slot="id" slot-scope="data">
										<strong>{{ paginate(data.index, search.page, search.limit) }}</strong>
									</template>

									<template slot="name" slot-scope="data">
										{{ data.value ? data.value : '-' }}
									</template>

									<template slot="artikul" slot-scope="data">
										<div v-for="artikul in data.item.vendorCodes">{{ artikul.vendor }}<br></div>
									</template>

									<template slot="genderName" slot-scope="data">
										{{ data.value ? data.value : '-' }}
									</template>
									<template slot="weight" slot-scope="data">
										{{ data.value ? data.value + ' гр' : '-' }}
									</template>

									<template slot="forPos" slot-scope="data">
										<span v-if="data.value" class="fa fa-check"></span>
									</template>

									<template slot="wrapped" slot-scope="data">
										<span v-if="data.value" class="fa fa-check"></span>
									</template>


									<template slot="code" slot-scope="data">
										<strong>{{ data.item.code }}</strong>
									</template>

									<template slot="value" slot-scope="data" class="col-md-8">
										{{ data.value ? data.value : '-' }}
									</template>

									<template slot="sort" slot-scope="data">
										{{ data.value ? data.value : '-' }}
									</template>
									<template slot="multi" slot-scope="data">
										{{ data.item.barcode }}<br>
									</template>
									<template slot="multiBarcode" slot-scope="data">
										<div v-for="(i, index) in data.item.multiBarcodes">
											{{ i.barcode }}<br>
										</div>
									</template>
									<template slot="contragents" slot-scope="data">
										<div v-for="(i, index) in data.item.contragents">
											{{ i.fullName }}<br>
										</div>
									</template>

									<template slot="actions" slot-scope="data">
										<!-- POPOVER TO CONFIRM DELETING THE REFERENCE -->
										<b-link @click="openCreate(data.item, 'edit')" :title="$t('Edit')"
											v-if="$can('edit', 'item')">
											<i class="fa fa-edit"></i>
										</b-link>
									</template>

								</b-table>
								<div v-if="loader" class="spinner-wrapper">
									<b-spinner variant="primary"></b-spinner>
								</div>
							</div>
							<!-- TABLE -->

							<nav>
								<b-pagination :total-rows="total" :per-page="search.limit" v-model="search.page"
									:prev-text="$t('pagination.prev')" :next-text="$t('pagination.next')"
									hide-goto-end-buttons />
							</nav>

						</b-card-body>
					</b-card>

				</transition>
				<vs-sidebar :click-not-close="true" position-right parent="body" default-index="1" color="primary"
					class="create-modal" spacer v-model="createModal">
					<b-container index="1" v-if="createModal">
						<create-modal @success="reloadList()" @not-close="closable = $event" @close="close"
							:companyType="companyType" :mode="mode" v-if="!uploadModal" :edit="item" />
						<Photos v-if="uploadModal" @close="close" />
					</b-container>
				</vs-sidebar>
			</div>
		</b-col>
		<b-modal size="xl" :no-close-on-backdrop="true" :ok-title="$t('actions.save')"
			:cancel-title="$t('actions.cancel')" @close="cancelModal" @cancel="cancelModal" @ok="save" v-model="isModal"
			:title="mode == 'create'
				? ('')
				: mode == 'edit'
					? ('')
					: ''
				">
			<AddUpdate1 :item="itemProp" :mode="mode" ref="addRef" />
		</b-modal>
		<b-modal v-model="excelModal" title="Подтвердите">
			<div>Скачивание уже готово, можете подтвердить !</div>
			<template #modal-footer>
				<download-excel v-if="excelItems.length > 0" @click="excelModal = false" size="sm"
					class="btn btn-success mr-2" :data="excelItems" :fields="json_fields" worksheet="My Worksheet"
					:name="`Товары`">
					<strong>Ok</strong>
				</download-excel>
			</template>
		</b-modal>
		<b-modal v-model="fullExcelModal" title="Подтвердите">
			<div>Скачивание уже готово, можете подтвердить !</div>
			<template #modal-footer>
				<download-excel v-if="fullExcelItems.length > 0" @click="fullExcelModal = false" size="sm"
					class="btn btn-success mr-2" :data="fullExcelItems" :fields="full_json_fields"
					worksheet="My Worksheet" :name="`Товары`">
					<strong>Ok</strong>
				</download-excel>
			</template>
		</b-modal>
	</b-row>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";
import CreateModal from "../../warehouse-management/goods/blocks/CreateModal";
import VisibleColumns from "../../warehouse-management/goods/blocks/VisibleColumns";
import GoodsService from "../../../services/goods.service";
import Photos from "../../warehouse-management/goods/blocks/Photos";
import FilterGoods from "../../warehouse-management/goods/blocks/FilterGoods";
import FilterGood from "../../warehouse-management/goods/blocks/Filter";
import { TokenService } from "../../../services/storage.service";
import ReferencesService from "../../../services/references.sevice";
import BarcodeModal from "../../point-of-sale/BarcodeModal";
import OrderHeaderService from '../../../OrderHeaderService'
import AddUpdate1 from "../../warehouse-management/goods/add-update"
import DepartmentsService from "../../../services/departments.sevice";
import { UserService } from "../../../services/user.service";
import UsersService from "../../../services/users.sevice";
import PricesService from "../../../services/prices.service";
import Multiselect from "vue-multiselect";
import WhDocument from "../../../services/wh-document.service";

export default {
	name: 'Goods',
	/**
	 *  Props
	 */
	props: {
		/**
		 *  Card caption
		 */
		caption: {
			type: String,
			default: 'Goods'
		}
	},
	/**
	 *
	 */
	data: () => {
		return {
			qop: false,
			json_fields: {
				"Спец-код": "barcode",
				"Название": "name",
				"Штрих-код": "multiBarcodeString",
				"Артикул": "artikul",
				"MXIK": "mxikCode",
				"Группа": "subCategoryName",
				"Категория": "sub2CategoryName",
				"Для продажи": "forPos"
			},
			full_json_fields: {
				"Спец-код": "sku",
				"Название": "itemName",
				"Штрих-код": "barcode",
				"Артикул": "artikul",
				"MXIK": "mxikCode",
				"Группа": "subCategoryName",
				"Категория": "subCategoryName1",
				"Для продажи": "forPos"
			},
			isModal: false,
			file: null,
			loader: true,
			refField: [
				{ key: 'id', label: 'ID', visible: true, changebale: false },
				{ key: 'multi', label: 'goods.special-barcode', visible: true, changebale: true },
				{ key: 'name', label: 'goods.name', 'class': 'td-30', visible: true, changebale: true },
				{ key: 'multiBarcode', label: 'goods.barcode', sortable: true, visible: true, changebale: true },
				{ key: 'artikul', label: 'goods.artikul', visible: true, changebale: true },
				{ key: 'mxikCode', label: 'MXIK', visible: true, changebale: true },
				{ key: 'colorName', label: 'goods.color', visible: false, changebale: true },
				{ key: 'docLastModifiedBy', label: 'Обнoвлён', visible: true, 'class': 'min-180', sortable: true, changebale: true },
				{ key: 'docChangedDate', label: 'Дата обновления', visible: true, 'class': 'text-center', sortable: true, changebale: true },
				{ key: 'changeForPosDescription', label: 'Изменять', visible: true, 'class': 'text-center', sortable: true, changebale: true },
				{ key: 'subCategoryName', label: 'goods.create.select-group', 'class': 'td-30', visible: true, changebale: true },
				{ key: 'sub2CategoryName', label: 'goods.category', 'class': 'td-30', visible: true, changebale: true },
				{ key: 'sub3CategoryName', label: 'goods.create.select-subcategory', 'class': 'td-30', visible: false, changebale: true },
				{ key: 'brandName', label: 'goods.brand', visible: false, changebale: true },
				{ key: 'size', label: 'goods.size', visible: false, changebale: true },
				{ key: 'genderName', label: 'goods.gender', visible: false, changebale: true },
				{ key: 'forPos', label: 'goods.create.forPos', 'class': 'td-30', visible: false, changebale: true },
				{ key: 'unitName', label: 'goods.create.unit', 'class': 'td-30', visible: false, changebale: true },
				{ key: 'manufacturerName', label: 'goods.manufacture', 'class': 'td-30', visible: false, changebale: true },
				{ key: 'weight', label: 'goods.weight', 'class': 'td-30', sortable: true, visible: false, changebale: true },
				{ key: 'contragents', label: 'goods.contragents', 'class': 'td-30', sortable: true, visible: false, changebale: true },
				{ key: 'sku', label: 'goods.sku', sortable: true, visible: false, changebale: true },
				// { key: 'actions', label: 'goods.actions', 'class': 'table_actions', visible: true, changebale: false }
			],
			items: [],
			fullExcelItems: [],
			excelItems: [],
			excelModal: false,
			fullExcelModal: false,
			mul: false,
			multiBarcodes: null,
			multiBarcodesAll: [],
			total: 0,
			mode: '',
			modeSecond: 'create',
			createModal: false,
			createModalSecond: false,
			item: null,
			itemSecond: null,
			closable: false,
			uploadModal: false,
			companyType: '',
			allCategory: [],
			confirmBarcodeGenerate: false,
			calculateCount: {},
			barcodeCount: 1,
			confirmPriceGenerate: false,
			pricingItem: {},
			priceCount: 1,
			departments: [],
			depId: null,
			departmentId: null,
			search: {
				page: 1,
				limit: 20,
				attributes: {}
			}
		};
	},
	/**
	 * Computed
	 */
	computed: {
		...mapState('excel', { 'ordersList': 'list', 'totalCount': 'total', 'itemProp': 'item' }),
		...mapGetters('goods', [
			'listGoods', 'totalItems',
		]),

		computedFields() {
			return this.filterColumns(this.refField)
		},
	},
	async created() {
		// this.multiBarcodesAll()
		this.setCompanyType();
		await this.loadCategory();
		this.fetchList();
	},
	methods: {
		...mapActions('goods', ['fetchGoods', 'getItemImagesById']),
		look(i) {
		},
		// multiBarcodesAll(){
		// 	for(let i=0;i<this.items.length;i++){
		// 		console.log(this.items.multiBarcodes[i].barcode)
		// 	}
		// },
		async save(bvModalEvt) {
			bvModalEvt.preventDefault()
			await OrderHeaderService.saveList(this.$refs.addRef.itemss);
			this.isModal = false
		},
		async addButton() {
			this.mode = "create"
			this.isModal = !this.isModal
		},
		cancelModal() {
			this.isModal = false
		},
		deletePopover(index) {
			const refName = `popover${index}`;
			this.$refs[refName].$emit('close')
		},
		openCreate(item, mode = 'create') {
			this.item = item;
			// this.item. = item;
			this.mode = mode;
			setTimeout(() => {
				this.createModal = true
			}, 100);
		},
		// openCreateSecond(item = null, mode = 'create') {
		// 	this.qop = true
		// 	this.itemSecond = item;
		// 	this.modeSecond = mode;
		// 	setTimeout(() => {
		// 		this.createModalSecond = true
		// 	}, 100);
		// },
		setCompanyType() {
			this.companyType = TokenService.getDepartmentType()
		},
		barcodeGenerate(item) {
			this.calculateCount = item;
			UsersService.getPermittedDepartments().then(res => {
				this.departments = res.data.permittedDepartments
			})
			this.confirmBarcodeGenerate = true;
			this.multiBarcodesAll = this.calculateCount.multiBarcodes.map(e => e.barcode)
			if (this.multiBarcodesAll.length === 1)
				this.multiBarcodes = this.multiBarcodesAll[0]
			if (this.multiBarcodesAll.length > 1) {
				return this.mul = true
			}
		},
		priceGenerate(item) {
			this.pricingItem = item
			this.multiBarcodesAll = this.pricingItem.multiBarcodes.map(e => e.barcode)
			if (this.multiBarcodesAll.length === 1)
				this.multiBarcodes = this.multiBarcodesAll[0]
			UsersService.getPermittedDepartments().then(res => {
				this.departments = res.data.permittedDepartments
			})
			this.confirmPriceGenerate = true
		},
		submitBarcodeGenerate() {
			let link = '?barcode=' + this.multiBarcodes + '&itemId=' + this.calculateCount.id;
			if (this.depId)
				link += (`&depId=${this.depId}`)
			PricesService.getItemByPrice(link).then(res => {
				this.$router.push('/warehouse-management/goods/barcode/' + this.calculateCount.id + '/' + this.depId + '/' + this.multiBarcodes + '/' + this.barcodeCount);
				this.cancelBarcodeGenerate();
			}).catch(e => {
				this.$vs.notify({
					title: this.$t('words.error'),
					text: e.response.data.message,
					color: 'danger',
					icon: 'close',
					position: 'top-right'
				})
			})
		},
		cancelBarcodeGenerate() {
			this.barcodeCount = 1
			this.depId = null
			this.multiBarcodes = null
			this.confirmBarcodeGenerate = false;
		},
		submitPriceGenerate() {
			let link = '?barcode=' + this.multiBarcodes + '&itemId=' + this.pricingItem.id;
			if (this.departmentId)
				link += `&depId=${this.departmentId}`
			PricesService.getItemByPrice(link).then(res => {
				this.$router.push(`/goods/print-prices/${this.pricingItem.id}/${this.departmentId}/${this.priceCount}/${this.multiBarcodes}`);
				this.cancelPriceGenerate();
			}).catch(e => {
				this.$vs.notify({
					title: this.$t('words.error'),
					text: e.response.data.message,
					color: 'danger',
					icon: 'close',
					position: 'top-right'
				})
			})
		},
		cancelPriceGenerate() {
			this.departmentId = null
			this.priceCount = 1
			this.multiBarcodes = null
			this.confirmPriceGenerate = false;
		},
		reloadList() {
			setTimeout(() => {
				this.fetchList();
			}, 200);
			this.createModal = false;
			this.createModalSecond = false;
			this.uploadModal = false;

		},
		paginate(index, page_size, page_number) {
			--page_size;
			return (page_number * page_size) + index + 1;
		},
		fetchList() {
			this.loader = true;
			if (this.companyType === 'SHOP') {
				this.allCategory.filter(el => {
					if (el.code === 'MAGAZIN') {
						this.search.attributes.categoryId = el.id
					}
				})
			}
			GoodsService.fetchGoodsChangeForPos(this.search).then(response => {
				this.items = response.data.items;
				this.total = response.data.total;
				this.loader = false;
			}).catch(() => {
				this.loader = false;
			});
		},
		async loadCategory() {
			await ReferencesService.getReferenceChildren(`WAREHOUSE_CATEGORY`).then(response => {
				this.allCategory = response.data;
			})
		},
		filterColumns(columns = []) {
			return columns.filter(column => {
				if (column.visible) {
					column.label = this.$t(column.label);
					return column
				}
			})
		},
		columnListener($event) {
			this.refField = $event
		},
		remove(id) {
			GoodsService.deleteItem(id).then(response => {
				this.reloadList();
			});
		},
		close() {
			this.createModal = false;
			this.mode = 'create';
			this.item = null;
			this.uploadModal = false;
		},
		async openPhotos(item) {
			await this.$store.commit('goods/setCurrentItem', item);
			await this.$store.commit('goods/setPhotoUploadError', { message: false, boolean: false });
			await this.getItemImagesById(item.id);
			this.uploadModal = true;
			this.openCreate(item);
		},
		closeOthers(id) {
			Object.keys(this.$refs).map(key => {
				if (key !== `popover${id}`) {
					const refName = `popover${id}`;
					this.$refs[refName].$emit('close')
				}
			});
		},
		filterItems($event) {
			this.search.attributes = $event;
			this.fetchList();
		},
		downloadExcel($event) {
			this.search.attributes = $event;
			this.loader = true;
			if (this.companyType === 'SHOP') {
				this.allCategory.filter(el => {
					if (el.code === 'MAGAZIN') {
						this.search.attributes.categoryId = el.id
					}
				})
			}
			GoodsService.fetchExcelGoods(this.search).then(response => {
				this.excelItems = response.data;
				this.loader = false;
			}).catch((e) => {
				this.loader = false;
			}).finally((f) => {
				this.excelModal = true
			})
		},
		downloadFullExcel($event) {
			this.loader = true;

			GoodsService.fetchFullExcelGoods().then(response => {
				this.fullExcelItems = response.data;
				this.loader = false;
			}).catch((e) => {
				this.loader = false;
			}).finally((f) => {
				this.fullExcelModal = true
			})
		}
	},
	/**
	 * components
	 */
	components: {
		FilterGoods,
		Photos,
		CreateModal,
		VisibleColumns,
		FilterGood,
		BarcodeModal,
		AddUpdate1,
		Multiselect
	},
	watch: {
		'search.page': {
			handler() {
				this.fetchList(this.search);
			}
		},
		'depId': {
			handler(d) {
				if (d) {
					let data = {
						selected: 'sklad',
						link: `?depIds=${d}&contragentId=null&catId=14&date=null&barcode=${this.calculateCount.barcode}&name=null&subId=null&sub2Id=null&sub3Id=null&genderId=null&brandId=null&colorId=null&multiBarcode=null`
					}
					WhDocument.balancePrice(data).then(res => {
						if (res.MAGAZIN) {
							let sum = 0
							res.MAGAZIN.forEach(item => {
								this.departments.forEach(dep => {
									if (dep.id === d)
										sum += item.deps[dep.name].inventory
								})
							})
							this.barcodeCount = sum
						} else
							this.barcodeCount = 1
					})
				}
			}
		}
	}
}
</script>

<style scoped>
label {
	display: inline-block;
	background-color: green;
	color: white;
	padding: 0.2rem;
	font-family: sans-serif;
	border-radius: 0.3rem;
	cursor: pointer;
	margin-top: 1rem;
}

/*.upload-btn-wrapper {*/
/*	position: relative;*/
/*	overflow: hidden;*/
/*	display: inline-block;*/
/*}*/

/*.btn {*/
/*	border: 1px solid gray;*/
/*	color: gray;*/
/*	background-color: lawngreen;*/
/*	padding: 1px 1px;*/
/*	border-radius: 8px;*/
/*	font-size: 20px;*/
/*	font-weight: bold;*/
/*}*/

/*.upload-btn-wrapper input[type=file] {*/
/*	font-size: 100px;*/
/*	position: absolute;*/
/*	left: 0;*/
/*	top: 0;*/
/*	opacity: 0;*/
/*}*/
.table-wrapper {
	position: relative;
	padding: 5px;
}

.spinner-wrapper {
	position: absolute;
	background: rgba(32, 28, 32, 0.49);
	left: 0;
	right: 0;
	text-align: center;
	top: 0;
	bottom: 0;
	padding-top: 35px;
	z-index: 5;
}
</style>
